import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';

/**
 * Bloquea el acceso por URL directa a una ruta cuyo `data.permission` el usuario
 * no posee. El menú ya oculta esas secciones; esto es la capa defensiva del front
 * (el backend sigue siendo la barrera real con 403).
 *
 * Espera a que los permisos estén cargados (carga async tras el login) vía
 * `PermissionService.ensureLoaded()` antes de decidir. Las rutas sin
 * `data.permission` (ej. dashboard) pasan siempre.
 */
export const permissionGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const permissions = inject(PermissionService);
  const router = inject(Router);

  const required = route.data['permission'] as string | string[] | undefined;
  if (!required) return true;

  const keys = Array.isArray(required) ? required : [required];

  return permissions.ensureLoaded().pipe(
    map(() =>
      permissions.canAny(keys) ? true : router.createUrlTree(['/home/dashboard']),
    ),
  );
};
